import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import { T } from '@/util/Localize';
import type { DroneNotice } from './drone-rules';

export interface DroneAirspaceNoticeProps {
    notice: DroneNotice | null;
}

/** ROBO-854. The FAA airspace for the drone products, as one alert: a warning on a no-fly date, otherwise information. */
export function DroneAirspaceNotice({ notice }: DroneAirspaceNoticeProps) {
    if (!notice) return null;
    return (
        <Alert
            severity={notice.severity}
            data-testid="drone-airspace-notice"
            role={notice.severity === 'warning' ? 'alert' : 'status'}
        >
            <AlertTitle>{notice.heading}</AlertTitle>
            <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
                {notice.lines.map(line => (
                    <Typography component="li" variant="body2" key={line}>
                        {line}
                    </Typography>
                ))}
            </Box>
            <Typography variant="caption" component="p" sx={{ mt: 1 }}>
                {T('National parks and local rules were not checked.')}
            </Typography>
        </Alert>
    );
}
